<template>
  <div>
    <wc-data-box
      title='Work Order Types'
      showArchived
      :showArchivedStatus='showArchived'
      @toggleShowArchived='showArchived = !showArchived'
      @add='addType'
      :loading='isLoading'
      showHelp
      :helpText='helpText'
    >
      <v-data-table
        dense
        :items='filteredTypes'
        :headers='headers'
        :items-per-page='-1'
        hide-default-footer
        @click:row='editType'
      >
        <template v-slot:item.name='{ item }'>
          {{ item.name }} <wc-archived v-if='item.archived'></wc-archived>
        </template>
        <template v-slot:item.color='{ item }'>
          <v-badge dot inline :color='item.color'></v-badge>
        </template>
      </v-data-table>
    </wc-data-box>

    <wc-dialog
      title='Type Details'
      :showDialog='showDialog'
      width='350'
      @cancel='showDialog = false'
      @save='updateType'
      :disableButtons='!isFormValid'
    >
      <v-form v-model='isFormValid' ref='form'>
        <v-text-field
          disabled
          label='Name'
          v-model='woTypeCopy.name'
          :rules='[rules.required]'
        ></v-text-field>
        <wc-color-picker v-model='woTypeCopy.color'></wc-color-picker>
        <v-select
          class='mt-6'
          label='Default labour type'
          :items='labour'
          item-text='description'
          item-value='id'
          v-model='woTypeCopy.default_labour_type'
          hint='Used on phones when adding labour'
          persistent-hint
        ></v-select>
        <v-text-field
          id='price'
          class='mt-6'
          label='Default price'
          v-model='woTypeCopy.minimum_price'
          reverse
          append-icon='mdi-currency-usd'
          @focus='focusPrice'
          hint='the minumum charge for this type of work order'
          persistent-hint
          :rules='[rules.decimal]'
        ></v-text-field>
        <v-checkbox
          disabled
          class='mt-6'
          label='Generate invoice from WO?'
          v-model='woTypeCopy.requires_invoice'
        ></v-checkbox>
        <br>
        <v-textarea
          label='Default invoice resolution'
          v-model='woTypeCopy.default_resolution'
          outlined
          hint='Used on the Work Orders - Ready for Office page'
          persistent-hint
        ></v-textarea>
      </v-form>
      <template v-slot:dialog-actions v-if='woTypeCopy.id && !woTypeCopy.use_for_template'>
        <v-btn text color='error' @click='toggleArchive'>
          <span v-if='woTypeCopy.archived'>UN-Archive</span>
          <span v-else>Archive</span>
        </v-btn>
      </template>
    </wc-dialog>
  </div>
</template>

<script>
import settingsAPI from '../../api/settings'
import servicesAPI from '@/modules/assets/api/services'
import formRules from '@/mixins/formRules'
import miscServices from '@/services/misc'
import WCColorPicker from '@/components/pickers/WCColorPicker'
import _ from 'lodash'

export default {
  name: 'wo-types',
  mixins: [formRules],
  props: {
    division: {
      required: true
    }
  },
  data: () => ({
    isLoading: true,
    isSaving: true,
    showDialog: false,
    isFormValid: false,
    showArchived: false,
    colors: [
      'indigo',
      'deep-purple',
      'purple',
      'blue',
      'light-blue',
      'cyan',
      'info',
      'primary',
      'teal',
      'success',
      'light-green',
      'lime',
      'yellow',
      'amber',
      'warning',
      'pink',
      'deep-orange',
      'error',
      'brown',
      'blue-grey',
      'grey',
      'secondary'
    ],
    woTypes: [],
    woTypeCopy: {},
    labour: [],
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'Colour', value: 'color', align: 'center' }
    ],
    helpText: `
      These work order types are used both to classify a work order, but also to classify the "Category" type for invoices.<br><br>
      Invoices generated from a work order will be given the same category as the work order's "work order type".<br><br>
      Work order types that have "Generate invoice from WO" set to TRUE will require the office process the work order, and generate
      an invoice from the product and labour added to that work order.<br><br>If you need to add a new work order type, or edit values that are locked... please contact Westcap. 
    `
  }),
  computed: {
    filteredTypes () {
      if (this.showArchived) {
        return this.woTypes
      }
      return this.woTypes.filter(w => w.archived === false)
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true
      this.woTypes = _.orderBy(await settingsAPI.getWOTypesForDivision(this.division), 'name')
      this.labour = await servicesAPI.getServicesForDivision(this.division.id)
      this.labour = _.filter(this.labour, l => l.is_labour == true)
      this.isLoading = false
    },
    editType (item) {
      this.woTypeCopy = _.cloneDeep(item)
      this.showDialog = true
    },
    addType () {
      this.woTypeCopy = {}
      this.woTypeCopy.division = this.division.id
      this.showDialog = true
      setTimeout(() => {
        this.$refs.form.reset()
      }, 50)
    },
    async updateType () {
      this.isSaving = true
      if (this.woTypeCopy.id) {
        this.woTypes = miscServices.replaceObject(this.woTypes, await settingsAPI.updateWOType(this.woTypeCopy))
      } else {
        this.woTypes.push(await settingsAPI.createWOType(this.woTypeCopy))
      }
      this.$store.dispatch('loadWOTypes', this.woTypes)
      this.showDialog = false
      this.isSaving = false
    },
    async toggleArchive () {
      this.isSaving = true
      this.woTypeCopy.archived = !this.woTypeCopy.archived
      this.updateType()
    },
    focusPrice() {
      setTimeout(() => {
        document.getElementById('price').select()
      }, 50)
    },
  },
  components: {
    'wc-color-picker': WCColorPicker
  }
}
</script>
